"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siftObjects = exports.objectFilter = exports.sifterMatch = void 0;
function isNestedSifterRule(rule) {
    return 'rules' in rule;
}
/**
 * tests the object toTest against the provided array of SifterRule.
 *
 * Returns true if any rule containing an action property matches the object
 * and the action result is "include" (e.g. action is "include" or action is
 * "sample" and the sampling decision is "include").
 *
 * Returns false if any rule containing an action property matches the object
 * and the action result is "exclude" (e.g. action is "exclude" or action is
 * "sample" and the sampling decision is "exclude"). This method also returns
 * false if not rule matches.
 *
 * Rules are processed serially and in order. Each rule branch is processed
 * completely before the next rule branch is processed. The first matching rule
 * terminates the matching process (i.e. multiple matches cannot occur).
 */
function sifterMatch(rules, toTest, prng) {
    for (const rule of rules) {
        if (rule.criteria(toTest)) {
            if (isNestedSifterRule(rule)) {
                const subsetResult = sifterMatch(rule.rules, toTest, prng);
                //only bubble the rule subset result if there was a match
                if (typeof subsetResult === 'boolean') {
                    return subsetResult;
                }
            }
            else {
                switch (rule.action) {
                    case 'exclude':
                        return false;
                    case 'include':
                        return true;
                    case 'sample':
                        return (prng || Math.random)() * 100 < rule.percent;
                }
            }
        }
    }
    //no matches
    return undefined;
}
exports.sifterMatch = sifterMatch;
/**
 * Tests if an object should be filtered in (true) or filtered out (true) based
 * on the provided ruleSet.
 * @param objToTest object to test
 * @param ruleSet rule set to use to test object
 * @param prng (optional) Math.random compatible PRNG
 * @returns false if object should be filtered out, otherwise true
 */
function objectFilter(objToTest, ruleSet, prng) {
    const result = sifterMatch(ruleSet.rules, objToTest, prng);
    return result || false;
}
exports.objectFilter = objectFilter;
/**
 * Filters objects to include only those which match a given rule set.
 *
 * This method returns a new array and does not mutate the input array.
 *
 * @param {Array<T>} objects log items to filter
 * @param {SifterRuleSet} ruleSet rule set to use to filter logs
 * @param {PRNG} prng (optional) Math.random compatible PRNG
 * @returns {Array<T>} filtered array of logs (does not mutate input array)
 */
function siftObjects(objects, ruleSet, prng) {
    return objects.filter((obj) => objectFilter(obj, ruleSet, prng));
}
exports.siftObjects = siftObjects;
//# sourceMappingURL=siftObjects.js.map